export const checkIsPrebidEnabled = (playlist) =>
    playlist[0] &&
    Object.keys(playlist[0].adschedule || {}).some((key) =>
        key.endsWith('prebid'),
    );
